import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "ui-phone-input__required"
}
const _hoisted_3 = {
  key: 1,
  class: "ui-phone-input__helper"
}
const _hoisted_4 = {
  key: 0,
  class: "ui-phone-input__error"
}
const _hoisted_5 = {
  key: 1,
  class: "ui-phone-input__helper-text"
}

import { computed, ref, onMounted, watch, nextTick } from "vue";
import type { Size } from "./types";

interface Props {
  modelValue?: string;
  label?: string;
  size?: Size;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  helperText?: string;
  id?: string;
  defaultCountry?: string;
  onlyCountries?: string[];
  preferredCountries?: string[];
  placeholder?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneInput',
  props: {
    modelValue: {},
    label: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: {},
    helperText: {},
    id: {},
    defaultCountry: { default: "US" },
    onlyCountries: {},
    preferredCountries: {},
    placeholder: {}
  },
  emits: ["update:modelValue", "update:country", "blur", "focus"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isFocused = ref(false);
const containerRef = ref<HTMLElement | null>(null);
const phoneInputId = computed(
  () => props.id || `phone-input-${Math.random().toString(36).substr(2, 9)}`
);

const wrapperClasses = computed(() => {
  const classes = ["ui-phone-input"];
  classes.push(`ui-phone-input--${props.size}`);
  if (props.disabled) classes.push("ui-phone-input--disabled");
  if (props.error) classes.push("ui-phone-input--error");
  return classes;
});

const setPlaceholder = () => {
  if (props.placeholder && containerRef.value) {
    nextTick(() => {
      const input = containerRef.value?.querySelector(".vue-tel-input input") as HTMLInputElement;
      if (input && props.placeholder) {
        input.placeholder = props.placeholder;
      }
    });
  }
};

onMounted(() => {
  setPlaceholder();
});

watch(
  () => props.placeholder,
  () => {
    setPlaceholder();
  }
);

watch(
  () => props.defaultCountry,
  () => {
    setPlaceholder();
  }
);

const handleUpdate = (value: string) => {
  emit("update:modelValue", value);
};

const handleCountryChange = (country: { iso2: string; name: string; dialCode?: string }) => {
  if (country && country.iso2) {
    emit("update:country", country.iso2.toUpperCase());
  }
};

const handleBlur = (event: FocusEvent) => {
  isFocused.value = false;
  emit("blur", event);
};

const handleFocus = (event: FocusEvent) => {
  isFocused.value = true;
  emit("focus", event);
};

return (_ctx: any,_cache: any) => {
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(wrapperClasses.value)
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: phoneInputId.value,
          class: "ui-phone-input__label"
        }, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['ui-phone-input__container', { 'ui-phone-input__container--focused': isFocused.value }]),
      ref_key: "containerRef",
      ref: containerRef
    }, [
      _createVNode(_component_vue_tel_input, {
        id: phoneInputId.value,
        "model-value": __props.modelValue,
        "onUpdate:modelValue": handleUpdate,
        onCountryChanged: handleCountryChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        defaultCountry: props.defaultCountry,
        autoDefaultCountry: false,
        onlyCountries: props.onlyCountries,
        preferredCountries: props.preferredCountries || [],
        mode: "international",
        disabled: __props.disabled,
        placeholder: props.placeholder
      }, null, 8, ["id", "model-value", "defaultCountry", "onlyCountries", "preferredCountries", "disabled", "placeholder"])
    ], 2),
    (__props.error || __props.helperText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (__props.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.error), 1))
            : (__props.helperText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.helperText), 1))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})